







































































































































































































































































































































import { Component, Vue } from 'vue-property-decorator';
import {
    mdbBtn,
    mdbIcon,
    mdbTooltip,
    mdbRow,
    mdbCol,
    mdbCard,
    mdbCardImage,
    mdbCardHeader,
    mdbCardBody,
    mdbCardTitle,
    mdbCardText,
    mdbCardFooter,
    mdbCardUp,
    mdbCardAvatar,
    mdbCardGroup,
    mdbView,
    mdbMask,
    mdbMasonry,
    mdbMasonryItem,
    mdbBadge
} from '@folky-tools/mdbvue';
import { usersService, businessPaymentOptionsService, notificationsService } from '@/services';
import { UserActionLogInfo } from '@/models/users/user-logging/user-action-log-info';
import { UserActionType } from '@/models/users/user-logging/user-action-type';
import { UserActionEntityType } from '@/models/users/user-logging/user-action-entity-type';
import { UserActionScopeType } from '@/models/users/user-logging/user-action-scope-type';
import { BusinessPaymentOptions } from '@/models/businesses/business-payment-options';

@Component({
    components: {
        mdbBtn,
        mdbIcon,
        mdbTooltip,
        mdbRow,
        mdbCol,
        mdbCard,
        mdbCardImage,
        mdbCardHeader,
        mdbCardBody,
        mdbCardTitle,
        mdbCardText,
        mdbCardFooter,
        mdbCardUp,
        mdbCardAvatar,
        mdbCardGroup,
        mdbView,
        mdbMask,
        mdbMasonry,
        mdbMasonryItem,
        mdbBadge,
        FormModal: () => import('@/components/shared/FormModal.vue'),
        EditPaymentBasics: () => import('@/components/businesses/EditPaymentBasics.vue'),
        EditPaymentOnDeliveryConfig: () => import('@/components/businesses/EditPaymentOnDeliveryConfig.vue'),
        EditBankTransferPaymentConfig: () => import('@/components/businesses/EditBankTransferPaymentConfig.vue'),
        EditPayPalPaymentConfig: () => import('@/components/businesses/EditPayPalPaymentConfig.vue'),
        EditRedsysPaymentConfig: () => import('@/components/businesses/EditRedsysPaymentConfig.vue'),
        EditPersonalBizumPaymentConfig: () => import('@/components/businesses/EditPersonalBizumPaymentConfig.vue'),
        AppSysBar: () => import('@/components/shared/AppSysBar.vue')
    }
})
export default class BusinessPaymentOptionsView extends Vue {
    private businessPaymentOptions: BusinessPaymentOptions = new BusinessPaymentOptions();
    private businessPaymentOptionsCopy: BusinessPaymentOptions = new BusinessPaymentOptions();

    private showEditPaymentBasics: boolean = false;
    private showEditPaymentOnDeliveryConfig: boolean = false;
    private showEditBankTransferPaymentConfig: boolean = false;
    private showEditPayPalPaymentConfig: boolean = false;
    private showEditRedsysPaymentConfig: boolean = false;
    private showEditPersonalBizumPaymentConfig: boolean = false;

    private savingPaymentBasics: boolean = false;
    private savingPaymentOnDeliveryConfig: boolean = false;
    private savingBankTransferPaymentConfig: boolean = false;
    private savingPayPalPaymentConfig: boolean = false;
    private savingRedsysPaymentConfig: boolean = false;
    private savingPersonalBizumPaymentConfig: boolean = false;

    private pageContentLoaded: boolean = false;

    private async mounted(): Promise<void> {
        this.$root.$emit('change-active-page', 'views.businesses.businessPaymentOptionsView.title', this.$route.query.businessName ? this.$route.query.businessName : '...');

        this.businessPaymentOptions = await businessPaymentOptionsService.getPaymentOptions(+this.$route.params.id);
        this.businessPaymentOptionsCopy = this.businessPaymentOptions.clone();

        await usersService.logUserAction(
            new UserActionLogInfo({
                type: UserActionType.HasVisited,
                entity: UserActionEntityType.Businesses,
                scope: UserActionScopeType.PaymentOptions,
                entityId: +this.$route.params.id
            })
        );
        setTimeout(() => this.switchPageContentToLoaded(), 10);
    }

    private switchPageContentToLoaded() {
        this.pageContentLoaded = true;

        this.reorderMasonryBlocks();
    }

    private reorderMasonryBlocks(): void {
        setTimeout(() => (this as any).$redrawVueMasonry(), 100);
    }

    private editPaymentBasics(): void {
        this.showEditPaymentBasics = true;
    }

    private async savePaymentBasics(): Promise<void> {
        this.savingPaymentBasics = true;
        try {
            const updateResult = await businessPaymentOptionsService.updatePaymentBasics(+this.$route.params.id!, this.businessPaymentOptions.paymentBasics);
            if (updateResult) {
                this.showEditPaymentBasics = false;
                this.businessPaymentOptionsCopy.paymentBasics = this.businessPaymentOptions.paymentBasics.clone();

                notificationsService.showToastSuccessNotification('views.businesses.businessPaymentOptionsView.basicDetails.save.successMessage');

                await usersService.logUserAction(
                    new UserActionLogInfo({
                        type: UserActionType.HasChanged,
                        entity: UserActionEntityType.Businesses,
                        scope: UserActionScopeType.PaymentAtLocation,
                        entityId: +this.$route.params.id
                    })
                );

                return;
            }
            notificationsService.showToastErrorNotification();
        } catch {
            notificationsService.showToastErrorNotification();
        } finally {
            this.savingPaymentBasics = false;
        }
    }

    private closePaymentBasicsEdition(): void {
        this.businessPaymentOptions.paymentBasics = this.businessPaymentOptionsCopy.paymentBasics.clone();
        this.showEditPaymentBasics = false;
    }

    private editPaymentOnDeliveryConfig(): void {
        this.showEditPaymentOnDeliveryConfig = true;
    }

    private async savePaymentOnDeliveryConfig(): Promise<void> {
        this.savingPaymentOnDeliveryConfig = true;

        try {
            const updateResult = await businessPaymentOptionsService.updatePaymentOnHandingOver(+this.$route.params.id!, this.businessPaymentOptions.paymentOnHandingOver);
            if (updateResult) {
                this.showEditPaymentOnDeliveryConfig = false;
                this.businessPaymentOptionsCopy.paymentOnHandingOver = this.businessPaymentOptions.paymentOnHandingOver.clone();

                notificationsService.showToastSuccessNotification('views.businesses.businessPaymentOptionsView.payOnDeliveryDetails.save.successMessage');

                await usersService.logUserAction(
                    new UserActionLogInfo({
                        type: UserActionType.HasChanged,
                        entity: UserActionEntityType.Businesses,
                        scope: UserActionScopeType.PaymentOnDelivery,
                        entityId: +this.$route.params.id
                    })
                );

                return;
            }
            notificationsService.showToastErrorNotification();
        } catch {
            notificationsService.showToastErrorNotification();
        } finally {
            this.savingPaymentOnDeliveryConfig = false;
        }
    }

    private closePaymentOnDeliveryConfigEdition(): void {
        this.businessPaymentOptions.paymentOnHandingOver = this.businessPaymentOptionsCopy.paymentOnHandingOver.clone();
        this.showEditPaymentOnDeliveryConfig = false;
    }

    private editBankTransferPaymentConfig(): void {
        this.showEditBankTransferPaymentConfig = true;
    }

    private async saveBankTransferPaymentConfig(): Promise<void> {
        this.savingBankTransferPaymentConfig = true;

        if ((this.$refs.bankTransferConfig as any).hasErrors()) {
            this.savingBankTransferPaymentConfig = false;
            return;
        }

        try {
            const updateResult = await businessPaymentOptionsService.updateBankTransferPaymentConfig(+this.$route.params.id!, this.businessPaymentOptions.bankTransferConfig);
            if (updateResult) {
                this.showEditBankTransferPaymentConfig = false;
                this.businessPaymentOptionsCopy.bankTransferConfig = this.businessPaymentOptions.bankTransferConfig.clone();

                notificationsService.showToastSuccessNotification('views.businesses.businessPaymentOptionsView.bankTransferDetails.save.successMessage');

                await usersService.logUserAction(
                    new UserActionLogInfo({
                        type: UserActionType.HasChanged,
                        entity: UserActionEntityType.Businesses,
                        scope: UserActionScopeType.BankTransferPayment,
                        entityId: +this.$route.params.id
                    })
                );

                return;
            }
            notificationsService.showToastErrorNotification();
        } catch {
            notificationsService.showToastErrorNotification();
        } finally {
            this.savingBankTransferPaymentConfig = false;
        }
    }

    private closeBankTransferPaymentConfigEdition(): void {
        this.businessPaymentOptions.bankTransferConfig = this.businessPaymentOptionsCopy.bankTransferConfig.clone();
        this.showEditBankTransferPaymentConfig = false;
    }

    private editPayPalPaymentConfig(): void {
        this.showEditPayPalPaymentConfig = true;
    }

    private async savePayPalPaymentConfig(): Promise<void> {
        this.savingPayPalPaymentConfig = true;

        if ((this.$refs.payPalConfig as any).hasErrors()) {
            this.savingPayPalPaymentConfig = false;
            return;
        }

        try {
            const updateResult = await businessPaymentOptionsService.updatePayPalPaymentConfig(+this.$route.params.id!, this.businessPaymentOptions.payPalConfig);
            if (updateResult) {
                this.showEditPayPalPaymentConfig = false;
                this.businessPaymentOptionsCopy.payPalConfig = this.businessPaymentOptions.payPalConfig.clone();

                notificationsService.showToastSuccessNotification('views.businesses.businessPaymentOptionsView.payPalDetails.save.successMessage');

                await usersService.logUserAction(
                    new UserActionLogInfo({
                        type: UserActionType.HasChanged,
                        entity: UserActionEntityType.Businesses,
                        scope: UserActionScopeType.PayPalPayment,
                        entityId: +this.$route.params.id
                    })
                );

                return;
            }
            notificationsService.showToastErrorNotification();
        } catch {
            notificationsService.showToastErrorNotification();
        } finally {
            this.savingPayPalPaymentConfig = false;
        }
    }

    private closePayPalPaymentConfigEdition(): void {
        this.businessPaymentOptions.payPalConfig = this.businessPaymentOptionsCopy.payPalConfig.clone();
        this.showEditPayPalPaymentConfig = false;
    }

    private editRedsysPaymentConfig(): void {
        this.showEditRedsysPaymentConfig = true;
    }

    private async saveRedsysPaymentConfig(): Promise<void> {
        this.savingRedsysPaymentConfig = true;

        if ((this.$refs.redsysConfig as any).hasErrors()) {
            this.savingRedsysPaymentConfig = false;
            return;
        }

        try {
            const updateResult = await businessPaymentOptionsService.updateRedsysPaymentConfig(+this.$route.params.id!, this.businessPaymentOptions.redsysConfig);
            if (updateResult) {
                this.showEditRedsysPaymentConfig = false;
                this.businessPaymentOptionsCopy.redsysConfig = this.businessPaymentOptions.redsysConfig.clone();

                notificationsService.showToastSuccessNotification('views.businesses.businessPaymentOptionsView.redsysDetails.save.successMessage');

                await usersService.logUserAction(
                    new UserActionLogInfo({
                        type: UserActionType.HasChanged,
                        entity: UserActionEntityType.Businesses,
                        scope: UserActionScopeType.RedsysPayment,
                        entityId: +this.$route.params.id
                    })
                );

                return;
            }
            notificationsService.showToastErrorNotification();
        } catch {
            notificationsService.showToastErrorNotification();
        } finally {
            this.savingRedsysPaymentConfig = false;
        }
    }

    private closeRedsysPaymentConfigEdition(): void {
        this.showEditRedsysPaymentConfig = false;
        this.businessPaymentOptions.redsysConfig = this.businessPaymentOptionsCopy.redsysConfig.clone();
    }

    private editPersonalBizumPaymentConfig(): void {
        this.showEditPersonalBizumPaymentConfig = true;
    }

    private async savePersonalBizumPaymentConfig(): Promise<void> {
        this.savingPersonalBizumPaymentConfig = true;

        if ((this.$refs.personalBizumConfig as any).hasErrors()) {
            this.savingPersonalBizumPaymentConfig = false;
            return;
        }

        try {
            const updateResult = await businessPaymentOptionsService.updatePersonalBizumPaymentConfig(+this.$route.params.id!, this.businessPaymentOptions.personalBizumConfig);
            if (updateResult) {
                this.showEditPersonalBizumPaymentConfig = false;
                this.businessPaymentOptionsCopy.personalBizumConfig = this.businessPaymentOptions.personalBizumConfig.clone();

                notificationsService.showToastSuccessNotification('views.businesses.businessPaymentOptionsView.bizumDetails.save.successMessage');

                await usersService.logUserAction(
                    new UserActionLogInfo({
                        type: UserActionType.HasChanged,
                        entity: UserActionEntityType.Businesses,
                        scope: UserActionScopeType.PersonalBizumPayment,
                        entityId: +this.$route.params.id
                    })
                );

                return;
            }
            notificationsService.showToastErrorNotification();
        } catch {
            notificationsService.showToastErrorNotification();
        } finally {
            this.savingPersonalBizumPaymentConfig = false;
        }
    }

    private closePersonalBizumPaymentConfigEdition(): void {
        this.businessPaymentOptions.personalBizumConfig = this.businessPaymentOptionsCopy.personalBizumConfig.clone();
        this.showEditPersonalBizumPaymentConfig = false;
    }
}
